import { Skeleton, Stack } from '@mui/material'
import type { FC } from 'react'

import { COLORS, unit } from '@hcr/ui'

import { BenefitsGroupLoading } from './common/benefits-group'

export const BenefitsLoading: FC = () => {
  return (
    <Stack border={`${unit(0.25)} solid ${COLORS.vaalea[700]}`} margin={0}>
      <Stack direction='column' gap={unit(2.5)} paddingTop={unit(4.5)} paddingBottom={unit(6)} paddingX={unit(4)}>
        <Skeleton width='60%' height={unit(8)} />
        <Skeleton width='40%' height={unit(6)} />
      </Stack>

      <BenefitsGroupLoading />
    </Stack>
  )
}
